export default __webpack_public_path__ + "static/media/ssc_trend.ba4437ec.png";